import React from 'react';
// Importez Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Importez les modules nécessaires (Pagination, Autoplay, Navigation)
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

// Importez les styles Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './GoogleReviews.css'; // Fichier CSS pour les styles

// Données fictives pour les avis clients
const reviewsData = [
  {
    id: 'gr1', // Préfixe pour éviter conflits d'ID potentiels
    author: 'Marie L.',
    rating: 5, // Note sur 5
    text: 'Un accueil chaleureux et des fromages absolument divins ! La Tomme des Pyrénées est à tomber. Je recommande vivement.',
  },
  {
    id: 'gr2',
    author: 'Jean Dupont',
    rating: 4,
    text: "Très bons produits et conseils avisés. Le Bleu des Causses était puissant comme j'aime. Un petit bémol sur l'attente le samedi matin.",
  },
  {
    id: 'gr3',
    author: 'Sophie T.',
    rating: 5,
    text: "Le Rocamadour est incroyable ! Crémeux, savoureux... parfait. L'équipe est passionnée et ça se sent. Bravo !",
  },
  {
    id: 'gr4',
    author: 'Pierre G.',
    rating: 4,
    text: "Belle découverte lors de nos vacances. La sélection est variée et de qualité. On reviendra !",
  },
  {
    id: 'gr5',
    author: 'Julie M.',
    rating: 5,
    text: "Une fromagerie comme on en fait plus ! Des produits locaux excellents et un service souriant. Le plateau apéro est un régal !",
  },
  {
    id: 'gr6',
    author: 'Marc B.',
    rating: 5,
    text: "Client régulier, jamais déçu. La qualité est toujours au rendez-vous. Mention spéciale pour le chèvre frais !",
  }
];

// Petit composant ou fonction pour afficher les étoiles
const StarRating = ({ rating }) => {
  const totalStars = 5;
  const stars = [];
  for (let i = 1; i <= totalStars; i++) {
    stars.push(
      <span key={i} className={`star-icon ${i <= rating ? 'filled' : 'empty'}`}>
        ★ {/* Utilisation d'un caractère étoile simple */}
      </span>
    );
  }
  return <div className="star-rating">{stars}</div>;
};


function GoogleReviews() {
  // Le lien Google que tu as fourni
  const googleReviewsLink = "https://www.google.com/maps/place/FROMAGERIE+CHEZ+PAUL/@43.6140952,1.0779211,17z/data=!3m1!4b1!4m6!3m5!1s0x12a94f33fba9e409:0xb691e333ef60d2c5!8m2!3d43.6140953!4d1.0827974!16s%2Fg%2F11vm58mrz8?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D";

  return (
    <section id="customer-reviews" className="reviews-section">
      <div className="container">
        <h2 className="platters-title">Vos Avis Nous Sont Précieux</h2>
        <p className="section-subtitle">
          Découvrez ce que nos clients pensent de nos produits et de notre accueil.
        </p>

        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
          className="myReviewsSwiper"
        >
          {reviewsData.map((review) => (
            <SwiperSlide key={review.id}>
              <div className="review-card">
                <div className="review-header">
                  <div className="review-author-info">
                    <p className="review-author-name">{review.author}</p>
                    <StarRating rating={review.rating} />
                  </div>
                </div>
                <p className="review-text">"{review.text}"</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="reviews-footer">
          <a
            href={googleReviewsLink} // Utilise la variable du lien ici
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Lire plus d'avis sur Google
          </a>
        </div>
      </div>
    </section>
  );
}

export default GoogleReviews;